import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

export interface StoreItemGroup {
  id: number;
  catalogId?: number | null;
  parentId?: number | null;
  name: string;
  abrv?: string | null;
  sortOrder?: number | null;
  level?: number | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const storeItemGroupsApi = {
  list: '/store-item-groups',
  detail: (id: number) => `/store-item-groups/${id}`,
  tree: (catalogId: number) => `/store-item-groups/tree/${catalogId}`,
};

export const useStoreItemGroupTree = (catalogId?: number | null) => {
  const { data, error, isLoading, mutate } = useSWR<StoreItemGroup[]>(
    catalogId != null && catalogId > 0 ? storeItemGroupsApi.tree(catalogId) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data: data ?? [], isLoading, isError: error, mutate };
};

export type StoreItemGroupTreeNode = StoreItemGroup & { children: StoreItemGroupTreeNode[] };

export function buildStoreItemGroupTree(flat: StoreItemGroup[]): StoreItemGroupTreeNode[] {
  const byId = new Map<number, StoreItemGroupTreeNode>();
  for (const row of flat) {
    byId.set(row.id, { ...row, children: [] });
  }
  const roots: StoreItemGroupTreeNode[] = [];
  for (const node of Array.from(byId.values())) {
    if (node.parentId != null && byId.has(node.parentId)) {
      byId.get(node.parentId)!.children.push(node);
    } else {
      roots.push(node);
    }
  }
  const sortNodes = (nodes: StoreItemGroupTreeNode[]) => {
    nodes.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || a.name.localeCompare(b.name));
    nodes.forEach((n) => sortNodes(n.children));
  };
  sortNodes(roots);
  return roots;
}
